export enum PaymentMethods {
  STRIPE = 'STRIPE',
  CARD = 'CARD',
  CASH = 'CASH',
  LINK = 'PAYMENT LINK'
}
